import deviceImg from "../assets/device.png"
import Navbar from "../components/Navbar"
import heroBg from "../assets/hero-bg.png"
import Footer from "../components/Footer"
import KeyFeatures from "../components/KeyFeatures"
import CtaSection from "../components/CtaSection"

import device1 from "../assets/prithvi-04.png"
import device2 from "../assets/prithvi-4g-basic.png"
import device3 from "../assets/prithvi-4g-plus.png"
import device4 from "../assets/prithvi-08.png"
import device5 from "../assets/prithvi-ais-140.png"

const ais140KeyFeatures = [
  {
    title: "Embedded eSIM",
    desc: "Devices with embedded eSIM that poll on dual servers and transmit data to government control centers and service providers.",
  },
  {
    title: "Emergency Button",
    desc: "Compatible with government-approved emergency and SOS buttons for immediate assistance during emergencies.",
  },
  {
    title: "IRNSS Compatible",
    desc: "Compatible with Indian Regional Navigation Satellite System for enhanced location accuracy and reliability.",
  },
  {
    title: "Multiple I/O Options",
    desc: "Multiple analog and digital I/O options for connecting external systems and accessories to extend device functionality.",
  },
  {
    title: "Intelligent Alerts",
    desc: "Multiple intelligent alarms and alerts to keep users informed about vehicle status, activity, and safety events.",
  },
  {
    title: "Mobile Access",
    desc: "Actionable alerts and insights delivered in real time through a simple web dashboard, iOS app, and Android app.",
  },
]

const scrollToAbout = () => {
  document
    .getElementById("about-ais140")
    ?.scrollIntoView({ behavior: "smooth" });
};

const industries = [
  {
    icon: "bus",
    title: "Intercity and Intracity Buses",
    desc: "Public, State and Private buses for passenger transport operations.",
  },
  {
    icon: "truck",
    title: "National Permit Commercial Vehicles",
    desc: "Long-distance transport and logistics operations across states.",
  },
  {
    icon: "taxi",
    title: "Cab/Taxi Services",
    desc: "Providers, operators, and owners of taxi and cab services.",
  },
  {
    icon: "car",
    title: "Car Rental Operators",
    desc: "Businesses providing short-term vehicle rental services.",
  },
  {
    icon: "institution",
    title: "Institutional Fleets",
    desc: "Educational institutions and other organizations with dedicated transport.",
  },
  {
    icon: "corporate",
    title: "Corporate Fleets",
    desc: "Companies maintaining their own transport fleet for business operations.",
  },
]

const IndustryIcon = ({ type }) => {
  const iconClass = "mx-auto mb-5 h-9 w-9 text-[#ed860f] sm:h-10 sm:w-10"

  const icons = {
    bus: (
      <>
        <rect x="10" y="14" width="44" height="28" rx="5" />
        <path d="M14 25H50" />
        <path d="M22 14V25" />
        <path d="M42 14V25" />
        <circle cx="21" cy="47" r="4" />
        <circle cx="43" cy="47" r="4" />
      </>
    ),
    truck: (
      <>
        <rect x="8" y="22" width="30" height="20" rx="3" />
        <path d="M38 27H49L56 34V42H38" />
        <path d="M13 42H51" />
        <circle cx="19" cy="47" r="4" />
        <circle cx="47" cy="47" r="4" />
      </>
    ),
    taxi: (
      <>
        <path d="M15 38H49" />
        <path d="M18 38L23 25H41L46 38" />
        <path d="M27 20H37" />
        <path d="M24 44H18" />
        <path d="M46 44H40" />
        <circle cx="23" cy="43" r="3" />
        <circle cx="41" cy="43" r="3" />
      </>
    ),
    car: (
      <>
        <path d="M12 37H52" />
        <path d="M17 37L23 25H41L47 37" />
        <path d="M23 25H41" />
        <circle cx="23" cy="43" r="4" />
        <circle cx="41" cy="43" r="4" />
      </>
    ),
    institution: (
      <>
        <path d="M16 48H48" />
        <path d="M20 48V24H44V48" />
        <path d="M26 48V38H38V48" />
        <path d="M26 30H28" />
        <path d="M36 30H38" />
        <path d="M26 35H28" />
        <path d="M36 35H38" />
        <path d="M18 24L32 14L46 24" />
      </>
    ),
    corporate: (
      <>
        <rect x="16" y="18" width="32" height="30" rx="3" />
        <path d="M24 26H27" />
        <path d="M37 26H40" />
        <path d="M24 34H27" />
        <path d="M37 34H40" />
        <path d="M28 48V40H36V48" />
        <path d="M12 48H52" />
      </>
    ),
  }

  return (
    <svg
      className={iconClass}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {icons[type] || icons.bus}
    </svg>
  )
}

const Section1 = () => {


  const containerClass =
    "mx-auto w-full max-w-[1600px] px-5 sm:px-8 lg:px-12 xl:px-20"

  const features = [
    { f: "Fuel Monitoring System", a: "Integrated with advanced fuel monitoring for tracking consumption.", s: "No support for fuel monitoring." },
    { f: "Add-On Device Compatibility", a: "Supports RFID Reader, Temperature Sensor, Panic Button, and Immobilizer.", s: "Limited or no add-on compatibility." },
    { f: "Driving Behavior Monitoring", a: "Tracks speed, harsh braking, rash turns, and acceleration.", s: "Basic or no driving behavior monitoring." },
    { f: "Accident Call Alerts", a: "Automatically calls emergency contacts and shares vehicle location.", s: "Not available or limited to manual alerts." },
    { f: "Build Quality", a: "Auto-grade components on a single grid gold plated PCB for zero defects.", s: "Standard PCB design prone to faults." },
    { f: "Voltage Protection", a: "Wide DC voltage range (10V–100V) for high compatibility.", s: "Limited voltage range, not suitable for all vehicles." },
    { f: "Device Casing", a: "IP65-certified (waterproof and dustproof).", s: "Standard casing without IP..." },
    { f: "CAN/OBD Compatibility", a: "Supports CAN/OBD for engine diagnostics and health monitoring.", s: "Standard casing without IP certifications." },
    { f: "Certifications", a: "IATF 1694:2016, ISO 14001:2015, ISO 9001:2015, ISO/IEC 27001:2013.", s: "Limited or basic certifications." },
    { f: "Quick KYC", a: "Complete KYC in less than 2 minutes and get certificates faster", s: "Delays in KYC and certificates" },
    { f: "Route Playback", a: "Advanced route playback with analytics.", s: "Basic route tracking." },
    { f: "Predictive Maintenance", a: "Helps reduce downtime with proactive maintenance alerts.", s: "Not available or limited capabilities." },
    { f: "Real-Time Alerts", a: "Instant notifications for overspeeding, long idling, and geofencing violations.", s: "Limited or delayed notifications." },
    { f: "User Dashboard", a: "Intuitive, cloud-based dashboard with multiple insights.", s: "Basic dashboard with limited data." },
    { f: "User Dashboard", a: "Intuitive, cloud-based dashboard with multiple insights.", s: "Basic dashboard with limited data." },
    { f: "VAHAN Portal Registration", a: "Maximum registrations in India’s VAHAN Portal.", s: "Limited or no registrations." },
    { f: "Manufacturer Trust", a: "Made by India’s first AIS140 IRNSS-certified company, Blackbox GPS Technology.", s: "No special recognition or certifications." },
    { f: "Dedicated Mobile App for iOS & Android", a: "Get a feature-loaded mobile app for both Android and iOS to manage your fleet on the go", s: "Basic or no mobile app support" },
  ];


  const devices = [
    { name: "Prithvi i40 4G (AIS140)", desc: "Reliable fleet tracking designed for compliance, visibility, and safety.", img: device5 },
    { name: "Prithvi i40 4GP", desc: "Reliable 4G GPS tracking designed for commercial fleet operations.", img: device1 },
    { name: "Prithvi 4G Basic", desc: "Essential vehicle tracking with dependable monitoring and safety features.", img: device2, popular: true },
    { name: "Prithvi 4G O8", desc: "Compact plug-and-play tracker for seamless installation and daily monitoring.", img: device4 },
    { name: "Prithvi 4G Plus", desc: "Feature-rich tracking solution with enhanced performance and fleet intelligence.", img: device3 },
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="relative mx-auto w-full max-w-[calc(100%-24px)] overflow-hidden rounded-b-[42px] bg-black sm:max-w-[calc(100%-32px)] lg:max-w-[calc(100%-48px)]">
        <Navbar />

        <div
          className="relative min-h-[560px] bg-cover bg-center sm:min-h-[620px] lg:min-h-[700px]"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="absolute inset-0 bg-black/65" />

          <div className="relative z-10 flex min-h-[560px] items-center justify-center px-5 pt-24 text-center sm:min-h-[620px] lg:min-h-[700px]">
            <div className="mx-auto max-w-[980px]">
              <h1 className="text-[34px] font-bold leading-tight text-white sm:text-5xl lg:text-[64px]">
                AIS-140 ICAT Certified Devices
              </h1>

              <div className="mx-auto mt-2 h-[3px] w-[260px] rounded-full bg-[#ed860f] sm:w-[420px] lg:w-[520px]" />

              <p className="mx-auto mt-7 max-w-[700px] text-sm leading-relaxed text-white/75 sm:text-base">
                State-of-the-art intelligent transport system for enhanced safety,
                efficiency, and control of your vehicle fleet.
              </p>

              <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
                <button
                  onClick={scrollToAbout}
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md bg-[#ed860f] px-8 py-4 text-sm font-medium text-white transition hover:bg-[#d9780d]"
                >
                  Explore Solutions
                </button>

                <a
                  href="/contact"
                  className="inline-flex min-w-[210px] items-center justify-center rounded-md border border-white px-8 py-4 text-sm font-medium text-white transition hover:bg-white hover:text-black"
                >
                  Contact us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section
        id="about-ais140"
        className="relative bg-white py-14 sm:py-16 lg:py-20"
      >
        <div className={`${containerClass} relative text-center`}>
          <h2 className="mb-5 text-3xl font-bold text-black sm:text-4xl lg:text-[42px]">
            About AIS-140
          </h2>

          <p className="mx-auto max-w-[1050px] text-sm font-semibold leading-relaxed text-black sm:text-[15px]">
            The Government of India designed an intelligent Transport System
            (ITS) under the Automotive Industry Standard (AIS-140) to ensure a
            state-of-art transport infrastructure with quality, efficiency and
            safety.
          </p>

          <p className="mx-auto mt-4 max-w-[1100px] text-sm leading-relaxed text-gray-400 sm:text-[15px]">
            The system is designed with the objective to centrally monitor all
            the passenger vehicles registered in the country and smoothen the
            traffic control to avoid congestions with improved safety, quality,
            efficiency & comfort and enhanced response time in emergencies.
          </p>

          <p className="mx-auto mt-3 max-w-[1100px] text-sm leading-relaxed text-gray-400 sm:text-[15px]">
            AIS-140 standard has specified by ARAI which states that all
            vehicles coming under the “passenger vehicles” category must be
            installed with vehicle tracking systems and emergency button
            approved by ARAI and ICAT.
          </p>

          <img
            src={deviceImg}
            alt="AIS device"
            className="absolute left-8 top-[100%] hidden w-24 rotate-[-18deg] lg:block xl:left-[13%] xl:w-32"
          />

          <img
            src={deviceImg}
            alt="AIS device"
            className="absolute right-8 top-[100%] hidden w-24 rotate-[18deg] lg:block xl:right-[13%] xl:w-32"
          />
        </div>
      </section>

      <KeyFeatures features={ais140KeyFeatures} />

      {/* new section */}
      
      <div className="max-w-[1800px] mx-auto p-4 md:p-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold mb-2">Advanced AIS-140 vs Standard AIS-140 Devices</h2>
          <p className="text-gray-500 text-sm md:text-base">See how our advanced solution delivers greater control, enhanced safety, and smarter fleet management.</p>
        </div>

        {/* 2. Flex Container  */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr_1.5fr] gap-4">

          {/* 1. Features Column */}
          <div className="flex flex-col rounded-2xl ">
            <div className="bg-[#f37a23] p-6 rounded-t-2xl text-white font-bold text-center h-20 flex items-center justify-center">Features</div>
            {features.map((item, i) => (
              <div key={i} className="bg-white border border-gray-200 p-4 text-gray-700 min-h-[80px] flex items-center">{item.f}</div>
            ))}
          </div>

          {/* 2. Advanced Column */}
          <div className="flex flex-col">
            <div className="bg-[#f37a23] p-6 rounded-t-2xl text-white font-bold text-center h-20 flex items-center justify-center">Veyonta Advanced AIS 140</div>
            {features.map((item, i) => (
              <div key={i} className="bg-[#fff5eb] border border-orange-100 p-4  text-gray-600 min-h-[80px] flex items-center">{item.a}</div>
            ))}
          </div>

          {/* 3. Basic Column */}
          <div className="flex flex-col">
            <div className="bg-[#808080] p-6 rounded-t-2xl text-white font-bold text-center h-20 flex items-center justify-center">Basic AIS 140 GPS Device</div>
            {features.map((item, i) => (
              <div key={i} className="bg-white border border-gray-200 p-4 text-gray-600 min-h-[80px] flex items-center">{item.s}</div>
            ))}
          </div>

        </div>
      </div>

      {/* new section 2 */}

      <div className="max-w-[1400px] mx-auto py-16 px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Choose the Right AIS-140 Device for Your Fleet</h2>
          <p className="text-gray-500 max-w-2xl mx-auto">Explore our range of AIS-140 certified GPS tracking devices designed to deliver compliance, real-time visibility, enhanced safety, and smarter fleet management for every business.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {devices.map((device, i) => (
            <div
              key={i}
              className={`relative p-6 bg-white rounded-2xl border-2 transition-all duration-300 shadow-sm hover:shadow-xl hover:border-orange-500 cursor-pointer ${device.popular ? 'border-orange-500' : 'border-gray-100'}`}
            >
              {/* "Most Popular" Label */}
              {device.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-[10px] px-3 py-1 rounded-full font-bold uppercase tracking-wider">
                  Most Popular
                </div>
              )}

              <div className="flex flex-col items-center text-center">
                <img src={device.img} alt={device.name} className="w-32 h-24 object-contain mb-6" />
                <h3 className="text-lg font-bold mb-3">{device.name}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{device.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Industries */}
      <section className="bg-white py-16 sm:py-20 lg:py-24">
        <div className={`${containerClass} text-center`}>
          <h2 className="mx-auto max-w-[980px] text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-[42px]">
            Industries can benefit from AIS-140
            <br className="hidden sm:block" />
            Certified Devices
          </h2>

          <div className="mx-auto mt-4 h-[3px] w-16 rounded-full bg-[#ed860f]" />

          <div className="mt-14 grid gap-x-10 gap-y-20 sm:grid-cols-2 lg:grid-cols-3 lg:gap-y-24">
            {industries.map((item, index) => (
              <div key={index} className="mx-auto max-w-[340px] text-center">
                <IndustryIcon type={item.icon} />

                <h3 className="mx-auto mb-4 max-w-[320px] text-xl font-bold leading-tight text-black sm:text-[22px]">
                  {item.title}
                </h3>

                <p className="mx-auto max-w-[300px] text-sm leading-7 text-gray-600 sm:text-[16px]">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <CtaSection />
      <Footer />


    </>
  )
}

export default Section1